import { c as _c } from "react/compiler-runtime";
import { formatCents } from 'betterplace-utils';
import { DonationListItem, Icon, LayoutCluster, LayoutStack } from 'design-system/client';
import { useTranslations, useLocale } from 'next-intl';
import { useMemo } from 'react';
import type { FEPPContentDonation } from '../../types';
import styles from './DonationItems.module.css';
import { useRelativeTimeFromTimestamp } from '@/helpers/hooks';
function HiddenAmount() {
  const $ = _c(2);
  const locale = useLocale();
  const shouldShowGermanVersion = locale === "de";
  if (shouldShowGermanVersion) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <><Icon name="heart" /><Icon name="euroSign" /></>;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  let t0;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <><Icon name="euroSign" /><Icon name="heart" /></>;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
function DonationListItemWrapper(t0) {
  const $ = _c(29);
  const {
    donation
  } = t0;
  const t = useTranslations("nextjs");
  const locale = useLocale();
  const timestamp = useRelativeTimeFromTimestamp(donation.createdAt);
  let t1;
  if ($[0] !== donation.message || $[1] !== t) {
    t1 = donation.message ? t("core.in_quotation_marks", {
      quote: donation.message
    }) : undefined;
    $[0] = donation.message;
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const comment = t1;
  const t2 = donation.id;
  let t3;
  if ($[3] !== donation.amountInCents || $[4] !== donation.showAmount || $[5] !== locale) {
    t3 = donation.showAmount ? formatCents(locale, donation.amountInCents) : <HiddenAmount />;
    $[3] = donation.amountInCents;
    $[4] = donation.showAmount;
    $[5] = locale;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t) {
    t4 = t("donation_list.by");
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== donation.displayName || $[10] !== t) {
    t5 = donation.displayName ?? t("donation_list.anonymous_user");
    $[9] = donation.displayName;
    $[10] = t;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t5) {
    t6 = <span>{t5}</span>;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t4 || $[15] !== t6) {
    t7 = <>{t4}{t6}</>;
    $[14] = t4;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t) {
    t8 = t("donation_list.show_more");
    $[17] = t;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t) {
    t9 = t("donation_list.show_less");
    $[19] = t;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== comment || $[22] !== donation.id || $[23] !== t3 || $[24] !== t7 || $[25] !== t8 || $[26] !== t9 || $[27] !== timestamp) {
    t10 = <DonationListItem key={t2} amount={t3} heading={t7} timestamp={timestamp} comment={comment} showMoreLabel={t8} showLessLabel={t9} />;
    $[21] = comment;
    $[22] = donation.id;
    $[23] = t3;
    $[24] = t7;
    $[25] = t8;
    $[26] = t9;
    $[27] = timestamp;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  return t10;
}
function ActualDonationList(t0) {
  const $ = _c(13);
  const {
    donationsToDisplay,
    itemsPerPage
  } = t0;
  let t1;
  if ($[0] !== donationsToDisplay || $[1] !== itemsPerPage) {
    t1 = donationsToDisplay.slice(0, itemsPerPage / 2).map(_temp);
    $[0] = donationsToDisplay;
    $[1] = itemsPerPage;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <LayoutStack space="100" className={styles.stack}>{t1}</LayoutStack>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== donationsToDisplay || $[6] !== itemsPerPage) {
    t3 = donationsToDisplay.slice(itemsPerPage / 2).map(_temp2);
    $[5] = donationsToDisplay;
    $[6] = itemsPerPage;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t3) {
    t4 = <LayoutStack space="100" className={styles.stack}>{t3}</LayoutStack>;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t2 || $[11] !== t4) {
    t5 = <LayoutCluster space="100" className={styles.container}>{t2}{t4}</LayoutCluster>;
    $[10] = t2;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}
function _temp2(donation_0) {
  if (!donation_0) {
    return null;
  }
  return <DonationListItemWrapper key={donation_0.id} donation={donation_0} />;
}
function _temp(donation) {
  if (!donation) {
    return null;
  }
  return <DonationListItemWrapper key={donation.id} donation={donation} />;
}
function SkeletonStack(t0) {
  const $ = _c(4);
  const {
    itemsPerPage
  } = t0;
  let items;
  if ($[0] !== itemsPerPage) {
    items = [];
    for (let i = 0; i < itemsPerPage / 2; i++) {
      items.push(<DonationListItem key={i} variant="skeleton" />);
    }
    $[0] = itemsPerPage;
    $[1] = items;
  } else {
    items = $[1];
  }
  const skeletonItems = items;
  let t1;
  if ($[2] !== skeletonItems) {
    t1 = <LayoutStack space="100" className={styles.stack}>{skeletonItems}</LayoutStack>;
    $[2] = skeletonItems;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function SkeletonList(t0) {
  const $ = _c(2);
  const {
    itemsPerPage
  } = t0;
  let t1;
  if ($[0] !== itemsPerPage) {
    t1 = <LayoutCluster space="100" className={styles.container}><SkeletonStack itemsPerPage={itemsPerPage} /><SkeletonStack itemsPerPage={itemsPerPage} /></LayoutCluster>;
    $[0] = itemsPerPage;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
function DonationList(t0) {
  const $ = _c(5);
  const {
    receivedDonationsCount,
    donationsToDisplay,
    itemsPerPage
  } = t0;
  const shouldDisplaySkeleton = donationsToDisplay && donationsToDisplay.length === 0;
  if (!receivedDonationsCount) {
    return null;
  }
  if (shouldDisplaySkeleton) {
    let t1;
    if ($[0] !== itemsPerPage) {
      t1 = <SkeletonList itemsPerPage={itemsPerPage} />;
      $[0] = itemsPerPage;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  if ($[2] !== donationsToDisplay || $[3] !== itemsPerPage) {
    t1 = <ActualDonationList donationsToDisplay={donationsToDisplay} itemsPerPage={itemsPerPage} />;
    $[2] = donationsToDisplay;
    $[3] = itemsPerPage;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}
function DonationItems(t0) {
  const $ = _c(10);
  const {
    receivedDonationsCount,
    donationsToDisplay,
    itemsPerPage,
    donationFormUrl
  } = t0;
  const t = useTranslations("nextjs.donation_list");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <HiddenAmount />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const amount = t1;
  if (receivedDonationsCount === 0) {
    let t2;
    if ($[1] !== t) {
      t2 = t("be_the_first");
      $[1] = t;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    let t3;
    if ($[3] !== donationFormUrl || $[4] !== t2) {
      t3 = <div className={styles.initialItemWrapper}><DonationListItem variant="cta" amount={amount} ctaText={t2} ctaLink={donationFormUrl} /></div>;
      $[3] = donationFormUrl;
      $[4] = t2;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    return t3;
  }
  let t2;
  if ($[6] !== donationsToDisplay || $[7] !== itemsPerPage || $[8] !== receivedDonationsCount) {
    t2 = <DonationList receivedDonationsCount={receivedDonationsCount} donationsToDisplay={donationsToDisplay} itemsPerPage={itemsPerPage} />;
    $[6] = donationsToDisplay;
    $[7] = itemsPerPage;
    $[8] = receivedDonationsCount;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}
export default DonationItems;